<template>
    <div class="container-style">
      <v-container max-width="1200" style="padding-top: 50px; padding-bottom: 80px;">
        <v-row>

          <v-col  v-for="item in featuring" :key="item._id" cols="12" md="6" xl="3" class="">
            <v-card @click="navigateToArticle(item.urlTitle)" class="mx-auto  card-height" max-width="600" elevation="12">
              <v-img :src="`${UPLOADS}/h400-${item.imageUrl}`" height="400" cover class="v-card-image"></v-img>
              <v-card-title>
                {{ item.title }}
              </v-card-title>
  
              <v-card-text>
                <div>
                  {{ item.intro }}
                </div>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="orange" text="Více"></v-btn>
              </v-card-actions>
            </v-card>
          </v-col>


        </v-row>
      </v-container>
    </div>
  </template>

<script setup lang="ts">
import { onMounted, ref } from 'vue';
import axiosInstance from '@/services/axiosInstance';
import { useRouter } from 'vue-router';

const UPLOADS = import.meta.env.VITE_UPLOADS;

// Přístup k routeru
const router = useRouter();

const featuring = ref<{ _id: string; urlTitle: string; title: string;  intro: string;  imageUrl: string  }[]>([]);

onMounted(async () => {
  try {
    const response = await axiosInstance.get(`/articles/featured`);
    featuring.value = response.data; // Načtení položek do `menuTitles`
  } catch (error) {
    console.error('Chyba při načítání menu položek:', error);
  }
});


const navigateToArticle = (urlTitle: string) => {
  router.push(`/articles/${urlTitle}`);
};

</script>


<style scoped>

.card-height {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
}

.blur {
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px); /* Pro Safari */
  background-color: rgba(0, 0, 0, 0.6);
}

.container-style {
    min-height: 1000px;
    background-color: white;
  background-position: top center;
  background-size: cover;
  background-repeat: no-repeat;
}
</style>